import { render, staticRenderFns } from "./ForgotPasswordSended.vue?vue&type=template&id=2f2f73b6&scoped=true&"
import script from "./ForgotPasswordSended.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordSended.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordSended.vue?vue&type=style&index=0&id=2f2f73b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f73b6",
  null
  
)

export default component.exports